export default "__VITE_ASSET__ce2cdf20__"